"use client";

import { AlertCircle, CheckCircle } from "lucide-react";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();
  const hasOpenToast = toasts.some((toast) => toast.open !== false);

  return (
    <ToastProvider>
      {hasOpenToast && (
        <div
          className="fixed inset-0 z-[99] bg-black/40 lg:hidden pointer-events-none"
          aria-hidden
        />
      )}
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isDestructive = variant === "destructive";
        return (
          <Toast key={id} variant={variant} {...props}>
            {isDestructive ? (
              <AlertCircle className="h-5 w-5 shrink-0 text-red-600 mt-0.5" />
            ) : (
              <CheckCircle className="h-5 w-5 shrink-0 text-blue-600 mt-0.5" />
            )}
            <div className="grid flex-1 gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
